export default __webpack_public_path__ + "static/media/right_arrow_black.b768a7af.svg";